import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { MDBDataTable } from "mdbreact";
import React, { useEffect, useMemo, useState } from "react";
import { MutatingDots } from 'react-loader-spinner';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Card, CardBody, CardTitle, Col, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";
import "./datatables.scss";
// import "./CourseRegistrationsList.css";



const CourseRegistrationsList = (props) => {

  console.log(props);


  dayjs.extend(utc);
  dayjs.extend(timezone);

  document.title = "Course Registrations List | Technical Hub - All Registrations";

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Course Registrations", link: "#" },
    { title: "Course Registrations List", link: "#" },
  ];

  const [registrationsData, setRegistrationsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [registrationToDelete, setRegistrationToDelete] = useState(null);


  const [modalOpen, setModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [certModal, setCertModal] = useState(false);
  const [selectedCerts, setSelectedCerts] = useState([]);
  const [selectedTermFeeDetails, setSelectedTermFeeDetails] = useState([]);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleCertModal = () => setCertModal(!certModal);
  const [syllabusModal, setSyllabusModal] = useState(false);
  const [selectedSyllabus, setSelectedSyllabus] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleOpenSyllabus = (pdfUrl) => {
    setSelectedSyllabus(pdfUrl);
    setSyllabusModal(true);
  };

  const handleCloseSyllabus = () => {
    setSelectedSyllabus(null);
    setSyllabusModal(false);
  };



  const handleOpenList = (list, title) => {

    setSelectedData(list || []);
    setModalTitle(title);
    setModalOpen(true);
  };
  console.log(registrationsData)

  const handleOpenTermFeeDetailsList = (list, title) => {
    setSelectedTermFeeDetails(list || []);
    setModalTitle(title);
    setModalOpen(true);
  };


  const handleOpenCertifications = (certs) => {
    setSelectedCerts(certs || []);
    setCertModal(true);
  };

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const backendImgUrl = process.env.REACT_APP_BACKEND_IMAGE_URL;



  useEffect(() => {
    props.setBreadcrumbItems('Course Registrations', breadcrumbItems);
    fetchRegistrationsData();
  }, []);



  const fetchRegistrationsData = async () => {
    try {
      const response = await api.get(`${backendUrl}get-course-registrations`);
      if (response.status === 200) {
        setRegistrationsData(response.data.courseRegistrations);
        console.log(response.data.courseRegistrations)
        setLoading(false);
      }
    } catch (error) {

      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!registrationToDelete) return;

    setIsDeleting(true);
    try {
      const response = await api.delete(
        `${backendUrl}delete-course-registration/${registrationToDelete._id}`
      );

      if (response.status === 200) {
        toast.success("Registration deleted successfully", { theme: "light" });

        setRegistrationsData(prev =>
          prev.filter(r => r._id !== registrationToDelete._id)
        );
      }
    } catch (error) {
      console.error("Error deleting registration:", error);
      toast.error(error.response?.data?.message || "Error deleting registration", {
        theme: "light",
      });
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
      setRegistrationToDelete(null);
    }
  };

  const toggleDeleteModal = (registration) => {
    setRegistrationToDelete(registration);
    setShowDeleteModal(!showDeleteModal);
  };
  const data = useMemo(() => {
    return {
      columns: [
        { label: "S.no", field: "s_no", sort: "asc", width: 150 },
        // { label: "Order", field: "order", sort: "asc", width: 50 },
        { label: "Course", field: "course_name", sort: "asc", width: 150 },
        { label: "program", field: "program_name", sort: "asc", width: 150 },
        { label: "Technology", field: "technology_name", sort: "asc", width: 100 },
        { label: "App Program", field: "app_program", sort: "asc", width: 150 },
        // { label: "Technology Icon", field: "technology_icon", sort: "asc", width: 100 },
        // { label: "Description", field: "description", sort: "asc", width: 100 },
        { label: "Passout year", field: "passout_year", sort: "asc", width: 100 },
        // { label: "Note", field: "note", sort: "asc", width: 100 },
        { label: "Fee", field: "fee", sort: "asc", width: 150 },
        { label: "Seats", field: "seats", sort: "asc", width: 150 },
        { label: "Terms", field: "no_of_terms", sort: "asc", width: 150 },
        { label: "Term Fee Details", field: "term_fee_details", sort: "asc", width: 150 },
        // { label: "Eligible Roll Nos", field: "roll_no", sort: "asc", width: 150 },
        // { label: "Eligible Branches", field: "branch", sort: "asc", width: 150 },
        // { label: "Eligible Passout Years", field: "eligible_passout_years", sort: "asc", width: 150 },
        // { label: "Eligible colleges", field: "college", sort: "asc", width: 150 },
        // { label: "Gender", field: "gender", sort: "asc", width: 150 },
        { label: "Registration Start Date", field: "registration_start_date", sort: "asc", width: 150 },
        { label: "Registration End Date", field: "registration_end_date", sort: "asc", width: 150 },
        { label: "Course Start Date", field: "course_start_date", sort: "asc", width: 150 },
        { label: "Course End Date", field: "course_end_date", sort: "asc", width: 150 },
        // { label: "Mentors", field: "mentors", sort: "asc", width: 100 },
        // { label: "Support Mentors", field: "support_mentors", sort: "asc", width: 100 },
        // { label: "Syllabus", field: "syllabus", sort: "asc", width: 100 },
        // { label: "Certifications", field: "certifications", sort: "asc", width: 150 },

        { label: "Payment Status", field: "status", sort: "asc", width: 150 },
        { label: "Registration Status", field: "registration_status", sort: "asc", width: 150 },
        { label: "Actions", field: "actions", sort: "asc", width: 150 },
        // { label: "Added By", field: "added_by", sort: "asc", width: 150 },
      ],
      rows: Array.isArray(registrationsData) && registrationsData.length > 0
        ? registrationsData.map((registration, ind) => ({
          s_no: ind + 1,
          // order: registration?.order,

          course_name: registration?.course?.course_name,
          program_name: registration?.program_name,
          app_program: registration?.app_program,

          technology_name: registration?.technology?.technology_name,

          // technology_icon: registration?.technology_icon ? (
          //   <div className="w-100 d-flex justify-content-center align-items-center">
          //     <img
          //       src={`${backendImgUrl}technology-icons/${registration?.technology_icon}`}
          //       alt="Technology Logo"
          //       style={{ width: "50px", height: "50px", textAlign: "center" }}
          //     />
          //   </div>
          // ) : (
          //   "No Icon"
          // ),

          // description: registration?.description,

          passout_year: registration?.passout_year,
          // note: registration?.note,
          fee: registration?.fee,
          seats: registration?.seats,
          no_of_terms: registration?.no_of_terms,

          term_fee_details: (
            <Button
              size="sm"
              color="primary"
              onClick={() =>
                handleOpenTermFeeDetailsList(
                  registration?.term_fee_details,
                  "Term Fee Details"
                )
              }
            >
              View
            </Button>
          ),

          college: (
            <Button
              size="sm"
              color="primary"
              onClick={() =>
                handleOpenList(
                  registration.eligible_college,
                  "Eligible Colleges"
                )
              }
            >
              View
            </Button>
          ),

          roll_no: (
            <Button
              size="sm"
              color="success"
              onClick={() =>
                handleOpenList(
                  registration.eligible_rollNos,
                  "Eligible Roll Nos"
                )
              }
            >
              View
            </Button>
          ),

          branch: (
            <Button
              size="sm"
              color="info"
              onClick={() =>
                handleOpenList(
                  registration.eligible_branch,
                  "Eligible Branches"
                )
              }
            >
              View
            </Button>
          ),

          eligible_passout_years: (
            <Button
              size="sm"
              color="warning"
              onClick={() =>
                handleOpenList(
                  registration.eligible_passout_year,
                  "Eligible Passout Years"
                )
              }
            >
              View
            </Button>
          ),

          // gender: registration?.gender,



          // mentors: Array.isArray(registration.mentors)
          //   ? registration.mentors.join(", ")
          //   : registration.mentors,

          // support_mentors: Array.isArray(registration.support_mentors)
          //   ? registration.support_mentors.join(", ")
          //   : registration.support_mentors,

          // syllabus: (
          //   <Button
          //     size="sm"
          //     color="info"
          //     onClick={() => handleOpenSyllabus(registration.syllabus)}
          //   >
          //     View
          //   </Button>
          // ),

          // certifications: (
          //   <Button
          //     size="sm"
          //     color="success"
          //     onClick={() =>
          //       handleOpenCertifications(registration.certifications)
          //     }
          //   >
          //     View
          //   </Button>
          // ),
          course_start_date: dayjs(registration?.course_start_date).tz("Asia/Kolkata")
            .format("DD-MM-YYYY"),
          course_end_date: dayjs(registration?.course_end_date).tz("Asia/Kolkata")
            .format("DD-MM-YYYY"),
          registration_start_date: dayjs(registration.registration_start_date)
            .tz("Asia/Kolkata")
            .format("DD-MM-YYYY"),

          registration_end_date: dayjs(registration.registration_end_date)
            .tz("Asia/Kolkata")
            .format("DD-MM-YYYY"),

          status: registration?.status === 1 ? "Active" : "Inactive",
          registration_status:
            registration?.registration_status === 1 ? "Open" : "Closed",

          actions: (
            <div>
              <Link
                to={`/edit-course-registration/${registration._id}`}
                className="btn btn-info btn-sm me-2"
              >
                Edit
              </Link>

              {/* 
          <Button
            color="danger"
            size="sm"
            className="me-2"
            onClick={() => toggleDeleteModal(registration)}
          >
            Delete
          </Button> 
          */}
            </div>
          ),

          // added_by: registration?.added_by || "Unknown"
        }))
        : [],

    };
  }, [registrationsData]);

  return (
    <React.Fragment>
      <Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <Col className="col-12">
          <Card>
            <CardBody className="d-flex justify-content-between align-items-center">
              <CardTitle className="h4">Course Registrations List</CardTitle>
              <Link to="/add-course-registration">
                <Button type="button" color="primary" className="waves-effect waves-light">Add Registration</Button>
              </Link>
            </CardBody>
            <CardBody>
              {loading ? (
                <div className="row">
                  <div className="col-md-2 offset-5">
                    <MutatingDots
                      visible={true}
                      height="100"
                      width="100"
                      color="#2B3A4A"
                      secondaryColor="#2B3A4A"
                      radius="12.5"
                      ariaLabel="mutating-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                </div>
              ) : (
                <MDBDataTable responsive bordered data={data} />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal isOpen={showDeleteModal}>
        <ModalHeader toggle={() => toggleDeleteModal(null)}>
          Delete Registration
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete this registration?
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => toggleDeleteModal(null)}
            disabled={isDeleting}  // prevent cancel spam
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={handleDelete}
            disabled={isDeleting} // disable while deleting
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </ModalFooter>
      </Modal>



      {/* Generic List & Term Fee Details Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{modalTitle}</ModalHeader>
        <ModalBody>
          {/* If it's term fee details */}
          {modalTitle === "Term Fee Details" ? (
            selectedTermFeeDetails?.length > 0 ? (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Term Name</th>
                    <th>Amount</th>
                    <th>End Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedTermFeeDetails.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.term_name}</td>
                      <td>{item?.amount}</td>
                      <td>{dayjs(item?.end_date).tz("Asia/Kolkata").format("YYYY-MM-DD")}</td>
                      <td>{item?.status === 1 ? "Active" : "Inactive"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No Term Fee Details available</p>
            )
          ) : (
            /* Otherwise render normal list */
            <>
              {selectedData?.length > 0 ? (
                <ul>
                  {selectedData.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p>All are Eligible</p>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>Close</Button>
        </ModalFooter>
      </Modal>


      {/* Certifications Modal */}
      <Modal isOpen={certModal} toggle={toggleCertModal} size="md">
        <ModalHeader toggle={toggleCertModal}>Certifications</ModalHeader>
        <ModalBody>
          {selectedCerts.length > 0 ? (
            <ListGroup>
              {selectedCerts.map((cert) => (
                <ListGroupItem key={cert._id} className="d-flex align-items-center">
                  <div className="w-100 d-flex justify-content-between">
                    <img
                      src={`${backendImgUrl}certification-icons/${cert.logo}`}
                      alt={cert.name}
                      style={{ width: "50px", height: "50px", marginRight: "15px" }}
                    />
                    <div className="d-flex justify-content-center align-items-center">
                      <span>{cert.name}</span>
                    </div>
                  </div>
                </ListGroupItem>
              ))}
            </ListGroup>
          ) : (
            <p>No certifications available</p>
          )}
        </ModalBody>
      </Modal>

      {/* Syllabus Modal */}
      <Modal isOpen={syllabusModal} toggle={handleCloseSyllabus} size="lg">
        <ModalHeader toggle={handleCloseSyllabus}>Syllabus</ModalHeader>
        <ModalBody style={{ height: "80vh" }}>
          {selectedSyllabus ? (
            <iframe
              src={`${backendImgUrl}course-registrations/${selectedSyllabus}`}
              title="Syllabus PDF"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          ) : (
            <p>No syllabus available</p>
          )}
        </ModalBody>
      </Modal>



    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CourseRegistrationsList);
